import { If } from 'react-if';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@zep/auth';
import { useSuspendedSubscribedSpaces } from '../../../../../services';
import { ExpiredSpaces } from '../ExpiredSpaces';
import { SubscribedSpaces } from '../SubscribedSpaces';
export const PlanSpaces = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    user
  } = useAuth();
  const {
    data: {
      data: spaceList
    }
  } = useSuspendedSubscribedSpaces(user?.hashId);
  const combinedSpaces = [...spaceList.activeSpaces, ...spaceList.readySpaces];
  return <div className="mx-auto flex w-[90%] max-w-[1140px] flex-col items-center pb-[80px] pt-[40px] md:pb-[120px] md:pt-[50px]" data-sentry-component="PlanSpaces" data-sentry-source-file="PlanSpaces.tsx">
      <div className="w-full">
        <h2 className="mb-[40px] text-[18px] font-bold leading-[140%] text-gray-900 md:text-[20px]">
          {t('subscription:SpaceList.paidSpaceManagement', '유료 스페이스 관리')}
        </h2>
        <div className="flex flex-col gap-[70px]">
          <SubscribedSpaces spaceList={combinedSpaces} data-sentry-element="SubscribedSpaces" data-sentry-source-file="PlanSpaces.tsx" />
          <If condition={!!spaceList.expiredSpaces.length} data-sentry-element="If" data-sentry-source-file="PlanSpaces.tsx">
            <ExpiredSpaces spaceList={spaceList.expiredSpaces} data-sentry-element="ExpiredSpaces" data-sentry-source-file="PlanSpaces.tsx" />
          </If>
        </div>
      </div>
    </div>;
};